import { useState, useContext } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';
import { useForm } from "react-hook-form"
import { AdminPersonsResponse } from '../../../backend/src/api/dto';

type FormValues = {
    password: string
}




function UserChangePassword({ changeFunction }: {
    changeFunction: Function,
}) {

    const [showModal, closeModal] = useContext(ModalContext);
    const { register, control, handleSubmit, getValues, setValue } = useForm<FormValues>({
        defaultValues: {
            password: ''
        }
    })

    const [sending, setSending] = useState(false);
    const [apiResult, setApiResult] = useState<null | { status: boolean, message?: string }>(null)

    const modalButtons = [
        {
            text: 'Confirm',
            icon: 'check',
            onClick: () => onSubmit(),
            isDisabled: apiResult?.status === true,
            style: 'primary'
        }, {
            text: apiResult?.status === true ? 'Close' : 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    const onSubmit = () => {
        setSending(true);
        return new Promise((resolve, reject) => {
            handleSubmit((data) => {
                changeFunction(data.password).then(() => {
                    setSending(false);
                    setApiResult({
                        status: true,
                        message: 'ok'
                    })
                }).catch((e: any) => {
                    setSending(false);
                    setApiResult(e)
                    resolve(1)
                })
            })()
        })

    }

    const generate = () => {
        setValue('password', (Math.random() + 1).toString(36).substring(2))
    }

    return (
        <Modal
            buttons={modalButtons}
            title={'Zmeniť heslo'}
            errorObject={apiResult}
            disableAllButtons={sending}
        >
            <div className="row">
                <div className="col-3 mt-1 text-end">
                    <label className="form-label mt-1">Nové heslo</label>
                </div>
                <div className="col-9">
                    {
                        apiResult?.status !== true ?
                            <div className="input-group mb-3">
                                <input type="text" {...register("password")} className="form-control" />
                                <button onClick={generate} className="btn btn-primary">Vygenerovať</button>
                                <small className="form-text text-muted">Heslo musí byť minimálne 5 znakov dlhé</small>
                            </div>
                            : <label className="form-label mt-2"><strong>{getValues().password}</strong></label>
                    }
                </div>
            </div>
        </Modal>
    )

}

export default UserChangePassword
